interface InputsData {
  Email: string;
  AGREEMENT: boolean;
  TYPE_FORM: string;
  PORTFOLIO: string;
  Theme: string;
  Name?: string;
  Message?: string;
  SUBSCRIBE?: boolean;
}

export const getFormData = (data: InputsData) => {
  const formData = new FormData();
  formData.append('Email', data.Email);
  formData.append('AGREEMENT', data.AGREEMENT.toString());
  formData.append('TYPE_FORM', data.TYPE_FORM); // contact / subscribe
  formData.append('PORTFOLIO', data.PORTFOLIO); // Noord
  formData.append('Theme', data.Theme); // Theme's name or 'None'

  if (data.Name) {
    formData.append('Name', data.Name);
  }

  if (data.Message) {
    formData.append('Message', data.Message);
  }

  if (data.SUBSCRIBE) {
    formData.append('SUBSCRIBE', data.SUBSCRIBE.toString());
  }

  return formData;
};
